import { render, staticRenderFns } from "./addSmarClock.vue?vue&type=template&id=69206c86&scoped=true&"
import script from "./addSmarClock.vue?vue&type=script&lang=js&"
export * from "./addSmarClock.vue?vue&type=script&lang=js&"
import style0 from "./addSmarClock.vue?vue&type=style&index=0&id=69206c86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69206c86",
  null
  
)

export default component.exports